// extracted by mini-css-extract-plugin
export default {"closeBtn":"successDelete_closeBtn__11sEs"};